import React, { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from '@reach/router';

import { RouteFC } from 'util/routeTypes';
import { Modal } from 'components/Modal';
import { CloseButton } from 'components/CloseButton';
import { ServiceHoursList } from './ServiceHoursList';

import { ServiceOffering } from 'olo-service';
import { SERVICE_HOURS_TEST_ID } from 'routes/Menu/BusinessInfo/ServiceHours/const';

import styles from './ServiceHoursModal.module.scss';
import { MerchantTitle } from 'components/MerchantTitle';

export const SERVICE_HOURS_MODAL_ID = 'service-hours';

type ServiceHoursProps = {
  service?: ServiceOffering;
  timezone: string;
};

export const ServiceHoursModal: RouteFC<ServiceHoursProps> = ({ service, timezone }) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const onClose = useCallback(() => navigate('./'), [navigate]);

  return (
    <Modal
      isOpen
      onClose={onClose}
      className={styles.modal}
      aria={{ labelledby: SERVICE_HOURS_MODAL_ID }}
      testId={SERVICE_HOURS_TEST_ID.modal}
    >
      <MerchantTitle i18nKey="helmet.titleServiceHours" />
      <div className={styles.modalWrapper}>
        <header className={styles.modalHeader}>
          <div className={styles.header} id={SERVICE_HOURS_MODAL_ID}>{t('orderingHours')}</div>
          {onClose && <CloseButton onClick={onClose} />}
        </header>
        {service && timezone && <ServiceHoursList serviceHours={service.hours} timezone={timezone} />}
      </div>
    </Modal>
  );
};
